import * as angular from 'angular';

function filterFunction() {
    return function (input: number) {
        if (!input) {
            return null;
        }

        switch (input) {
            case 1:
                return 'Visa';
            case 2:
                return 'MasterCard';
            default:
                throw new Error('Unsupported card type: ' + input);
        }
    };
}

angular
    .module('app.common')
    .filter('cardType', [filterFunction]);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/filters/cart-type.filter.ts